import type { Prototype } from "../prototype-types";

export const varunAppaswamiPrototypes: Prototype[] = [
  {
    id: "va-campaign-visibility-insights",
    name: "Campaign Visibility Insights",
    path: "/va/campaign-visibility-insights",
    description:
      "Preview likely queries and retailer search placement next to Advertising Settings.",
    owner: "Varun Appaswami",
    createdAt: "2026-09-10",
    lastUpdated: "2026-09-10",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/va-campaign-visibility-insights.png",
    project: "Campaign Visibility Insights",
  },
];
